exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".REnom{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}.REnom:hover{opacity:.7}._3rQFA{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}.fWhmH{position:relative;display:flex;box-sizing:border-box;align-items:center;justify-content:flex-start}.zw-dD{width:26px;min-width:26px;height:26px;min-height:26px}div[data-playable-hook=player-container][data-playable-in-full-screen=true] .zw-dD{width:35px;min-width:35px;height:35px;min-height:35px;background-size:15px 21px}div[data-playable-hook=player-container][data-playable-in-full-screen=true] .zw-dD ._1SihR{width:15px;height:21px}div[data-playable-hook=player-container][data-playable-in-full-screen=true] .zw-dD._21CFl{background-size:16px 21px}.zw-dD ._1SihR{width:11px;height:14px}", ""]);

// exports
exports.locals = {
	"controlButton": "REnom",
	"hidden": "_3rQFA",
	"playControl": "fWhmH",
	"playbackToggle": "zw-dD",
	"icon": "_1SihR",
	"paused": "_21CFl"
};